export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7485.a9ec3b85.jpg";